import * as ReactService from "@intech/react-service";
import { LGPDConsentimentoEntidade } from "../entidades/LGPDConsentimentoEntidade";

class LGPD extends ReactService.BaseService {
  constructor() {
    super("LGPD");
  }

  Buscar = (origem: number) =>
    this.CreateRequest<LGPDConsentimentoEntidade[]>(ReactService.RequestType.GET, `Buscar/${origem}`);

  BuscarTodos = () =>
    this.CreateRequest<LGPDConsentimentoEntidade[]>(ReactService.RequestType.GET, `BuscarTodos`);

  Inserir = (origem: number) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Inserir/${origem}`);

}

export const LGPDService = new LGPD();
